import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState } from './reducers';

export const selectFeature = createFeatureSelector<AuthState>('auth');

export const isAuthenticated = createSelector(selectFeature, state => state.authenticated);

export const supportedQuickActions = createSelector(selectFeature, state => state.supportedQuickActions);
